export const IconClose = ({ style, className }) => {
  // style={style}
  return (
    <svg
      style={style}
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.9974 18.9584C5.05573 18.9584 1.03906 14.9417 1.03906 10C1.03906 5.05835 5.05573 1.04169 9.9974 1.04169C14.9391 1.04169 18.9557 5.05835 18.9557 10C18.9557 14.9417 14.9391 18.9584 9.9974 18.9584ZM9.9974 2.29169C5.7474 2.29169 2.28906 5.75002 2.28906 10C2.28906 14.25 5.7474 17.7084 9.9974 17.7084C14.2474 17.7084 17.7057 14.25 17.7057 10C17.7057 5.75002 14.2474 2.29169 9.9974 2.29169Z"/>
      <path d="M7.63854 12.9834C7.48021 12.9834 7.32188 12.925 7.19687 12.8C6.95521 12.5584 6.95521 12.1584 7.19687 11.9167L11.9135 7.20002C12.1552 6.95835 12.5552 6.95835 12.7969 7.20002C13.0385 7.44168 13.0385 7.84168 12.7969 8.08335L8.08021 12.8C7.96354 12.925 7.79687 12.9834 7.63854 12.9834Z"/>
      <path d="M12.3552 12.9834C12.1969 12.9834 12.0385 12.925 11.9135 12.8L7.19687 8.08335C6.95521 7.84168 6.95521 7.44168 7.19687 7.20002C7.43854 6.95835 7.83854 6.95835 8.08021 7.20002L12.7969 11.9167C13.0385 12.1584 13.0385 12.5584 12.7969 12.8C12.6719 12.925 12.5135 12.9834 12.3552 12.9834Z"/>
    </svg>
  );
};
